/**
 * The download name from a Content-Disposition header, or null.
 *
 * The API now sends both forms of RFC 6266: an ASCII `filename="…"` for old
 * clients and `filename*=UTF-8''…` with the real, possibly Greek, name.
 * The parsers this replaces were written for the first form alone. One,
 * `/filename="?(.*?)"?$/`, is anchored at the END of the header, so with a
 * second parameter present it captured everything after `filename=` -- the
 * file would have downloaded as `X.pdf"; filename*=UTF-8''%CE…`.
 *
 * Preference order is the RFC's: filename* when present and decodable, then
 * the quoted filename, then a bare token.
 */
export function filenameFromContentDisposition(header) {
  if (!header || typeof header !== "string") return null;

  const extended = /filename\*\s*=\s*([^']*)'[^']*'([^;]+)/i.exec(header);
  if (extended) {
    try {
      const name = decodeURIComponent(extended[2].trim());
      if (name) return name;
    } catch {
      // A malformed percent-escape: fall through to the plain parameter.
    }
  }

  const quoted = /filename\s*=\s*"((?:\\.|[^"\\])*)"/i.exec(header);
  if (quoted && quoted[1]) return quoted[1].replace(/\\(.)/g, "$1");

  const bare = /filename\s*=\s*([^";\s][^;]*)/i.exec(header);
  if (bare && bare[1].trim()) return bare[1].trim();

  return null;
}
